<template lang="pug">
    div.thumbnail.is-relative.is-pointer(:class="{ 'hovering': hovering }", @click="onmobile(wine)", @mouseover="hovering = true", @mouseleave="hovering = false")
        div.thumbnail-content.has-text-blue.has-text-centered
            img.thumbnail-image(:src="'https://bo.herdadesaomiguel.com/assets/vinhos/' + wine.id + '.png'", @load="$emit('loaded')")
            p.is-size-15.is-uppercase.has-letter-spacing-20 {{ wine.referencia }}
            p.is-size-11.has-letter-spacing-200.has-text-blue-lighter {{ wine.ano }}
        div.thumbnail-hover(v-if="hovering")
            img(src="../assets/images/slider/plus.svg", @click="$bus.$emit('open-wine', wine)")

</template>

<script>

export default {
    name: 'wine-thumbnail',
    props: {
        wine: Object
    },
    data () {
        return {
            hovering: false
        }
    },
    methods: {
        onmobile (wine) {
            if (navigator.userAgent.match(/Mobi/i)) {
                this.$bus.$emit('open-wine', wine)
            }
        }
    }
}
</script>

<style  lang="scss" scoped>

.thumbnail-content {
    img {
        max-height: 350px;
    }
}

h1 {
    margin-top: 1px;
    font-size: 15px;
}

.thumbnail-hover {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 3rem;
    }
}

</style>
